import { createFileRoute } from '@tanstack/react-router'
import { ShieldAlert } from 'lucide-react'

import { getAuthLogoutUrl } from '@/features/auth/lib/app-origin'

export const Route = createFileRoute('/_public/unauthorized')({
  component: UnauthorizedPage,
})

function UnauthorizedPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="relative w-full max-w-md overflow-hidden rounded-2xl border border-border/40 bg-card/40 p-8 text-center shadow-2xl backdrop-blur-xl">
        {/* Decorative background gradients */}
        <div className="absolute -top-24 -left-24 h-48 w-48 rounded-full bg-destructive/20 opacity-50 blur-3xl" />
        <div className="absolute -bottom-24 -right-24 h-48 w-48 rounded-full bg-primary/20 opacity-50 blur-3xl" />

        <div className="relative z-10 flex flex-col items-center">
          <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-muted ring-8 ring-destructive/5">
            <ShieldAlert className="h-10 w-10 text-destructive" />
          </div>

          <h1 className="mb-3 text-3xl font-extrabold tracking-tight text-foreground">
            Access Denied
          </h1>

          <p className="mb-8 text-muted-foreground leading-relaxed">
            You must be explicitly invited by an organization administrator to access Veritab. If you believe this is a mistake, please contact your team lead.
          </p>

          <a
            href={getAuthLogoutUrl()}
            className="group relative inline-flex h-12 w-full items-center justify-center overflow-hidden rounded-lg bg-primary px-8 font-medium text-primary-foreground shadow-lg transition-all hover:scale-[1.02] hover:shadow-xl active:scale-[0.98]"
          >
            <span className="absolute inset-0 bg-white/20 opacity-0 transition-opacity group-hover:opacity-100" />
            Return to Login
          </a>
        </div>
      </div>
    </div>
  )
}
